import http from "@/api/instance";
import type { BaseRequestParamsType } from "@/api/requests/types";
import { BaseRequestType, DefaultResponseObjectType } from "@/api/requests/types";

export type DepartmentShortRequestType =BaseRequestType<
	{
		query: {
			managerIds?: string[];
			contractorTins?: string[];
			contractorIds?: number;
			departmentIds?: string[];
			regionalAdministrationIds?: string[];
			ekgIds?: string[];
			name?: string;
			filter?: string;
			hasEkg?: boolean;
			withDeleted?: boolean;
			isActiveEventMatrix?: boolean;
			filterToken?: string;
			sorting?: string;
			isRealization?: boolean;
			isMovement?: string;
			tin?: string;
			eventIds?: string;
			IsActive?: boolean;
			ExcludeContractorIds?: number[];
			ExcludeInstallationIds?: number[];
		} & BaseRequestParamsType;
	},
	DefaultResponseObjectType[]>

export const getShortDepartment: DepartmentShortRequestType = ({ params: { query }, cancelToken }) => http.httpCore.get("/directory/department/short", { params: query, cancelToken });
